/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_Send_AtInputs */

const en_messages_send_at = /** @type {(inputs: Messages_Send_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send at`)
};

const he_messages_send_at = /** @type {(inputs: Messages_Send_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לשליחה בתאריך`)
};

/**
* | output |
* | --- |
* | "Send at" |
*
* @param {Messages_Send_AtInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const messages_send_at = /** @type {((inputs?: Messages_Send_AtInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Send_AtInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_send_at(inputs)
	return he_messages_send_at(inputs)
});